
import './App.css'
import './styles/main.scss'
import {
  useContext, useState
} from 'react'
import {
  Switch,
  Route,
  Link, useLocation, Redirect
} from 'react-router-dom'
import BookTrip from './pages/BookTrip'
import MyBookings from './pages/MyBookings'
import StreetViewBG from './comps/StreetviewBG'
import TopNav from './comps/TopNav'
import MyLocation from './comps/MyLocation'
import {AppContext} from './context/AppContext'
import About from './pages/About'


function App() {

  const [fadeMobile, setFadeMobile] = useState(false)
  const {setGeoAddress, tripDetails} = useContext(AppContext)

  const fadeMobileView = () => {
    //NOT WORKING WITH IFRAME
    console.log('hide')
    if (fadeMobile) {
      setFadeMobile(false)
    } else {
      setFadeMobile(true)
    }
  }
  
  return (
    <div className="app">
        <StreetViewBG pressFunction={fadeMobileView}/>
        <div className={fadeMobile ? 'mobile-view fade-mobile' : 'mobile-view'}>
          <div className="mobile-wrap">
            <header className="page-header">
              <div className="page-header-wrap">
              <div className="page-title">
                <h1>Volta</h1>
              </div>
              <TopNav/>
              </div>
              <div className="volta-waves">
                <span id="wave-1" className="wave"></span>
                <span id="wave-2" className="wave"></span>
                <span id="wave-3" className="wave"></span> 
              </div>
            </header>
            <div className="main-content">
              <Switch>
                <Route exact path='/'>
                <MyLocation />
                <nav className="quick-nav">
                    {/* <Link id="quick-mybookings" className="quick-link" to='/mybookings'><h2>My bookings</h2></Link> */}
                    <Link id="quick-BookTrip" className="quick-link" to='/BookTrip'><h2>Book <br></br>a trip</h2></Link>
                    </nav>
                </Route>
                <Route path='/mybookings'>
                  <MyBookings/>
                </Route>
                <Route path='/booktrip'>
                  <BookTrip/>
                </Route>
                <Route path='/about'>
                  <About/>
                </Route>
                
              </Switch>
            </div>
          </div>
        </div>
    </div>
  );
}

export default App;
